import { STORAGE_KEYS, setItem } from '@/lib/storage';

// eslint-disable-next-line import/prefer-default-export
export function setRecentlyViewedProviderId(providerId: string | null) {
  if (providerId) {
    // modern storage (localStorage)
    setItem(STORAGE_KEYS.RECENTLY_VIEWED_PROVIDER_ID, providerId, 'local');

    // legacy cookie fallback
    // persist 7 days
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + 7);

    const cookieOptions = `path=/; expires=${expiry.toUTCString()}; Secure; SameSite=Lax`;

    document.cookie = `last_viewed_provider_profile_id=${providerId}; ${cookieOptions}`;
    document.cookie = `last_viewed_provider_profile_care_type=${encodeURIComponent('nanny')}; ${cookieOptions}`;
  }
}
